import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { AppConfigService, constants } from '@edassist/common';

@Component({
	selector: 'ea-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
	logoBaseUrl: string;
	environmentName: string;
	@Input() productName: string;
	@Input() isInternalAdmin: boolean;

	@Output() readonly searchApplicationByAppNumber = new EventEmitter<string>();

	ngOnInit(): void {
		this.logoBaseUrl = AppConfigService.getSettings().endPoints.cdn;
		this.environmentName = AppConfigService.getSettings().env.name;
	}
}
